// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"3f87af71","335":"a9961f60","351":"8a4ef70a","833":"a4a385c6","872":"ddf5d822"}[chunkId] + ".chunk.css";
};